import { useState } from "react";
import { collection, addDoc } from "firebase/firestore";
import db from "../../firebase/config";
// import Swal from 'sweetalert2';
// import withReactContent from 'sweetalert2-react-content';
import "./Form.css";

function Form() {
  // const MySwal = withReactContent(Swal)
  const [data, setData] = useState({
    name: "",
    email: "",
    message: "",
  });
  function onChangeData(e) {
    setData({ ...data, [e.target.name]: e.target.value });
  }
  function submit(e) {
    e.preventDefault();
    addDoc(collection(db, "users"), data);
    // MySwal.fire(
    //   'message sent successfully!',
    //   '',
    //   'success'
    // )
    alert("message sent successfully");
    setData({
      name: "",
      email: "",
      message: "",
    });
  }
  return (
    <div>
      <form onSubmit={(e) => submit(e)} className="Form">
        <div className="wrap">
          <input
            type="text"
            value={data.name}
            onChange={onChangeData}
            name="name"
            required
            placeholder="Your Name"
          />
        </div>
        <div className="wrap">
          <input
            type="text"
            value={data.email}
            onChange={onChangeData}
            name="email"
            required
            placeholder="Your Email"
          />
        </div>
        <div className="wrap">
          <textarea
            type="text"
            value={data.message}
            onChange={onChangeData}
            name="message"
            placeholder="Your Message"
            required
            rows="10"
          ></textarea>
        </div>
        <button>submit</button>
      </form>
    </div>
  );
}

export default Form;
